'use client'

import { useState } from 'react'
import type { RentToBuyCatalogContent } from '@/lib/rent-to-buy-catalog-content'

export default function RentToBuyCatalogIntro({ content }: { content: RentToBuyCatalogContent }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <section className="overflow-hidden rounded-[28px] bg-gradient-to-br from-[#07137e] to-[#005aa9] px-5 py-[22px] text-white shadow-[0_20px_20px_rgba(5,15,51,0.12)] lg:px-9 lg:py-[30px]">
      <h1 className="text-[26px] font-extrabold leading-[1.1] tracking-[-0.02em] lg:text-[30px]">{content.presentationTitle}</h1>
      <div className={expanded ? 'mt-3 space-y-3.5' : 'relative mt-3 max-h-[150px] overflow-hidden lg:max-h-none'}>
        <p className="text-[15px] font-medium leading-[1.5] text-white/85">{content.presentationDescription}</p>
        <div className="text-sm font-medium leading-[1.4] text-white/80 lg:text-[15px]">
          <p className="py-2.5"><strong className="font-extrabold text-white">✅ {content.savingsTitle}</strong> {content.savingsDescription}</p>
          <p className="border-t border-white/20 py-2.5"><strong className="font-extrabold text-white">✅ {content.freedomTitle}</strong> {content.freedomDescription}</p>
        </div>
        <p className="text-[13px] font-medium leading-[1.45] text-white/75 lg:text-sm">{content.presentationNote}</p>
        {!expanded && <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-[70px] bg-gradient-to-b from-transparent to-[#07579f] lg:hidden" />}
      </div>
      <button type="button" aria-expanded={expanded} onClick={() => setExpanded(!expanded)} className="mt-3 text-left text-sm font-bold underline underline-offset-2 lg:hidden">
        {expanded ? 'Mostra meno' : content.discoverMoreLabel}
      </button>
    </section>
  )
}
